import React, { useState } from 'react';

import { Media, Card, Spinner } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { getNotifications, readSingleNotification } from '@/actions/notifications';
import { Avatar, Pagination } from 'antd';
import { pushNotification } from './notificationHelper';

const AllNotifications = () => {
  const dispatch = useDispatch();

  const notification = useSelector(
    (state: any) => state?.notificationReducer?.notification
  );
  const [query, setQuery] = useState({
    page: 1,
    per_page: 15,
  });

  const markAsRead = (e, item) => {
    console.log(item);
    var tag = item?.readAt === null ? 'read' : 'unread';
    if (item?.readAt === null) {
      dispatch(readSingleNotification(item?.slug, tag));
    }
    pushNotification(item);
  };

  const handlePagination = (page: any, pageSize: any) => {
    setQuery({ page, per_page: pageSize });
    dispatch(getNotifications({ ...query, page, per_page: pageSize }));
  };

  return (
    <div>
      {
        <Card className="mb-3 border border-14">
          <h3 className="title text-center font-weight-normal m-3">
            All Notifications
          </h3>
          {notification?.loading ? (
            <Spinner
              animation="border"
              size="lg"
              style={{
                width: '60px',
                height: '60px',
              }}
              className="text-danger text-center mx-auto mb-3"
            />
          ) : (
            notification?.data?.data?.map((item, index) => (
              <div
                className="d-flex justify-content-between"
                key={index}
                style={{
                  background: item?.readAt === null ? '#f8f9fc' : 'transparent',
                }}
              >
                <Media
                  className={`
                      p-2
                      ${
                        item.readAt !== null
                          ? 'd-flex align-items-start'
                          : 'd-flex align-items-start status'
                      }
                      `}
                >
                  <Media left href="#" className="p-2">
                    {item?.avatar ? (
                      <Avatar size={45} src={item?.avatar} />
                    ) : (
                      <Avatar size="large" style={{ backgroundColor: '#283360' }}>
                        {item?.event_by?.first_name?.charAt(0).toUpperCase()}
                        {item?.event_by?.last_name?.charAt(0).toUpperCase()}
                      </Avatar>
                    )}
                  </Media>
                  <div className="d-flex">
                    <Media body className="p-2">
                      <div
                        className="notification-text"
                        onClick={(e) => markAsRead(e, item)}
                      >
                        <a
                          className="notification-title"
                          dangerouslySetInnerHTML={{ __html: item.title }}
                        ></a>
                      </div>
                      <div className="d-flex">
                        <small className="notification-time mr-1">{item.time}</small>
                        {item?.readAt === null ? (
                          <img
                            alt={'Tick read'}
                            style={{ height: '14px' }}
                            src={'/images/unread.svg'}
                            title="Unread"
                          />
                        ) : (
                          <img
                            className="mt-1"
                            alt={'Tick read'}
                            style={{ height: '8px' }}
                            src={'/images/tick.svg'}
                            title="Read"
                          />
                        )}
                        <input
                          type="checkbox"
                          className="my-auto ml-2"
                          checked={item?.readAt !== null}
                          onChange={(e) =>
                            dispatch(
                              readSingleNotification(
                                item?.slug,
                                item?.readAt === null ? 'read' : 'unread'
                              )
                            )
                          }
                          key={item.slug}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    </Media>
                  </div>
                </Media>
              </div>
            ))
          )}
        </Card>
      }
      {notification && notification?.data && !notification?.loading && (
        <div className="pagination-position">
          <Pagination
            total={notification?.meta?.total}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
            defaultPageSize={query?.per_page}
            defaultCurrent={query?.page}
            onChange={handlePagination}
            showSizeChanger
          />
        </div>
      )}
    </div>
  );
};

export default AllNotifications;
